import { gql } from "@apollo/client";

export default gql`
  query getUnassignedMemberCount($organizationId: Int!) {
    unassignedMemberCount(organizationId: $organizationId)
  }
`;
